<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t('createModel', { model: $tc('models.carrier', 1) }) }}
          <v-btn color="primary" outline @click="goTo('clientCarriers')"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <h2>{{ provider.name }} - {{ $tc('models.carrierSetting', 2) }}</h2>
                  </v-flex>

                  <v-flex xs12 sm12 md4 v-for="item in this.carrierSettings" :key="item.id" v-if="item.key !== 'limit' && item.key !== 'send_confirmation_mail'">
                    <v-text-field v-model="item.value"
                                  name="key"
                                  :label="item.key"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('key')"
                                  data-vv-name="key"
                                  :data-vv-as="$t('attrs.key')"
                                  required
                                  ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <br>
              <v-btn color="info" medium outline @click="openDialog" target="_blank" :disabled="false" slot="activator" :loading="false" class="add-services-btn">
                <font-awesome-icon icon="plus" class="mr-2"></font-awesome-icon>
                {{ $t('addServices') }}
              </v-btn>

              <v-btn color="primary" class="cancel-config-btn" outline @click="back" :loading="loading" :disabled="loading">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="primary" dark class="save-config-btn" :loading="loading" @click="submit" :disabled="loading">
                {{ $t('save') }}
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
      
      <v-flex v-if="services.length > 0" xs12>
        <v-card class="mt-4">
          <v-card-text>
            <v-data-table class="elevation-1"
              :headers="headers"
              :items="carrierServices"
              hide-actions
              :no-data-text="$t('noDataAvailable')">
              <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
              <template v-slot:items="props">
                <td> {{ props.item.name }} </td>
                <td> {{ props.item.code }} </td>
                <td> {{ serviceTypeName(props.item.code) }} </td>
                <td> {{ props.item.status }} </td>
                <td>
                  <v-btn color="primary" flat icon @click="editService(props.item)">
                    <font-awesome-icon icon="edit"></font-awesome-icon>
                  </v-btn>
                  <v-btn color="primary" flat icon @click="removeService(props.item)">
                    <font-awesome-icon icon="times" color="red"></font-awesome-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Add services dialog -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-text-field
                  :label="$t('attrs.name')"
                  v-model="service.name"
                  v-validate="''"
                  :error-messages="errors.collect('name')"
                  data-vv-name="name"
                  :data-vv-as="$t('attrs.name')"
                  >
                  </v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-select v-model="service.code"
                  :items="carrierServiceTypes"
                  item-value="id"
                  item-text="name"
                  :label="$t('attrs.code')"
                  v-validate="''"
                  :error-messages="errors.collect('code')"
                  data-vv-name="code"
                  :data-vv-as="$t('attrs.code')"
                  browser-autocomplete="hydra-new-password"
                  ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline class="mr-2 mb-2" @click="cancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" dark class="mr-2 mb-2" @click="save">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Setting from '@/client/setting'
import Carrier from '@/client/carrier'
import CarrierSetting from '@/client/carrier-setting'
import Provider from '@/client/provider'
import Enum from '@/client/enum'
import Service from '@/client/service'

export default {
  name: '',

  props: {},

  data () {
    return {
      carrier: {},
      carrierSettings: [],
      provider: {},
      services: [],
      loading: false,
      dialog: false,
      days: [],
      enums: [],
      service: {},
      carrierServiceTypes: [],
      headers: [
        { text: this.$t('attrs.name'), align: 'left', sortable: false, value: 'name' },
        { text: this.$t('attrs.code'), align: 'left', sortable: false, value: 'code' },
        { text: this.$t('attrs.code_name'), align: 'left', sortable: false, value: 'code_name' },
        { text: this.$t('attrs.status'), align: 'left', sortable: false, value: 'status' }
      ],
      isEdited: false,
      deletedServices: []
    }
  },

  components: {
  },

  methods: {
    async fetch () {
      this.loading = true

      this.carrier = await Carrier.findOne(this.$route.params.id)
      this.services = await Service.all({ where: { carrier_id: this.carrier.id }, per_page: 2000 })
      this.provider = await Provider.findOne(this.carrier.provider_id)
      this.enums = await Enum.all()
      this.carrierServiceTypes = this.enums.service_types[this.provider.code]
      this.carrierSettings = await CarrierSetting.all({
        where: { carrier_id: this.carrier.id },
        per_page: 15
      })

      this.loading = false
    },

    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        if (this.services.length < 1) {
          this.setNotification({ color: 'error', message: this.$t('servicesError')})
        }
        return
      }

      try {
        if (this.services.length < 1) {
          this.setNotification({ color: 'error', message: this.$t('servicesError')})
          return
        }
        this.loading = true

        //filter settings to remove unsaved ones
        this.carrierSettings = this.carrierSettings.filter(cs => (cs.value !== '*****'))

        await Carrier.clientAgreements({
          services: this.services,
          settings: this.carrierSettings,
          carrier_id: this.carrier.id,
          deleted_services: this.deletedServices
        })
        this.setNotification({
          color: 'success',
          message: this.$t('ownAgreementsCreation')
        })

        this.goTo('clientCarriers')
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    openDialog () {
      this.service = new Service({ status: 'active', service_type: 'national' })
      this.dialog = true
    },

    cancel () {
      this.dialog = false
    },

    editService (item) {
      this.service = item
      this.dialog = true
      this.isEdited = true
    },

    removeService (item) {
      var index = this.services.map((s) => { return s.name }).indexOf(item.name);
      if (index >= 0) {
        this.services.splice(index, 1)

        this.deletedServices.push(item.id)
      }
    },

    async save () {
      if(!this.isEdited) this.services.push(this.service)

      this.dialog = false
      this.isEdited = false
    },

    serviceTypeName (code) {
      var codeObj = this.carrierServiceTypes.filter(s => s.id == code)

      if (codeObj.length < 1) { return }
      return codeObj[0].name
    }
  },

  watch: {
  },

  computed: {
    carrierServices () {
      return this.services
    }
  },

  async mounted () {
    var ownAgreements = await Setting.byKey('user_own_agreements') || {}
    if (ownAgreements && ownAgreements.value == '0') this.goTo('dashboard')

    this.fetch()
  }
}
</script>

<style scoped>
  .add-services-btn {
    position: absolute;
    left: 32px;
    bottom: 15px;
    font-size: 16px;
  }

  .cancel-config-btn {
    bottom: 15px;
    position: absolute;
    right: 140px;
  }

  .save-config-btn {
    position: absolute;
    right: 32px;
    bottom: 15px;
  }
</style>
